/** Сэтгэгдлийн байгууллагын хариу гарчгийг байгууллагын нэрээр буцаана. */
export function partnerReplyLabel(review, fallbackCompanyName) {
  return (
    review?.company?.company_name ||
    review?.company?.name ||
    fallbackCompanyName ||
    "Байгууллага"
  );
}
